module.exports = __webpack_public_path__ + "img/Partners1.3da2a9ed.png";